import { useEffect } from 'react';

const useIntersectionObserver = ({
  containerRef,
  target,
  onIntersect,
  threshold = 0.1,
  rootMargin = '0px',
}) => {
  const root = containerRef?.current;

  useEffect(() => {
    const observer = new IntersectionObserver(onIntersect, {
      root,
      rootMargin,
      threshold,
    });

    const current = target.current;

    observer.observe(current);

    return () => {
      observer.unobserve(current);
    };
  }, [onIntersect]);
};

export default useIntersectionObserver;
